

const getJulianDate = (date = new Date()) => {
  const time = date.getTime();
  const tzoffset = date.getTimezoneOffset();
  
  return (time / 86400000) - (tzoffset / 1440) + 2440587.5;
};

const LUNAR_MONTH = 29.530588853;

const getLunarAge = (date = new Date()) => {
  const percent = getLunarAgePercent(date);
  const age = percent * LUNAR_MONTH;  return age;
};

const getLunarAgePercent = (date = new Date()) => {
  return normalize((getJulianDate(date) - 2451550.1) / LUNAR_MONTH);
};

const normalize = value => {
  value = value - Math.floor(value);
  if (value < 0) {
    value = value + 1;  
  }
  return value;
};

export const getLunarPhase = (date = new Date()) => {
  const age = getLunarAge(date);  if (age < 1.84566)
    return "New";
  else if (age < 5.53699)
    return "Waxing Crescent";
  else if (age < 9.22831)
    return "First Quarter";
  else if (age < 12.91963)
    return "Waxing Gibbous";
  else if (age < 16.61096)
    return "Full";
  else if (age < 20.30228)
    return "Waning Gibbous";
  else if (age < 23.99361)
    return "Last Quarter";
  else if (age < 27.68493)
    return "Waning Crescent";  return "New";
};

export const images = {
  "First Quarter": `<defs
      id="defs2">
     <linearGradient
        inkscape:collect="always"
        id="linearGradient3466">
       <stop
          style="stop-color:#483e37;stop-opacity:1;"
          offset="0"
          id="stop3462" />
       <stop
          style="stop-color:#483e37;stop-opacity:0;"
          offset="1"
          id="stop3464" />
     </linearGradient>
     <linearGradient
        inkscape:collect="always"
        id="linearGradient3208">
       <stop
          style="stop-color:#483e37;stop-opacity:1;"
          offset="0"
          id="stop3204" />
       <stop
          style="stop-color:#483e37;stop-opacity:0;"
          offset="1"
          id="stop3206" />
     </linearGradient>
     <linearGradient
        inkscape:collect="always"
        id="linearGradient2716">
       <stop
          style="stop-color:#aa8800;stop-opacity:1;"
          offset="0"
          id="stop2712" />
       <stop
          style="stop-color:#aa8800;stop-opacity:0;"
          offset="1"
          id="stop2714" />
     </linearGradient>
     <linearGradient
        inkscape:collect="always"
        id="linearGradient2346">
       <stop
          style="stop-color:#aa8800;stop-opacity:1;"
          offset="0"
          id="stop2342" />
       <stop
          style="stop-color:#aa8800;stop-opacity:0;"
          offset="1"
          id="stop2344" />
     </linearGradient>
     <linearGradient
        inkscape:collect="always"
        xlink:href="#linearGradient2346"
        id="linearGradient2348"
        x1="99.674171"
        y1="49.291107"
        x2="76.746254"
        y2="50.482792"
        gradientUnits="userSpaceOnUse" />
     <linearGradient
        inkscape:collect="always"
        xlink:href="#linearGradient2716"
        id="linearGradient2718"
        x1="115.232"
        y1="90.451729"
        x2="102.27573"
        y2="90.780258"
        gradientUnits="userSpaceOnUse" />
     <linearGradient
        inkscape:collect="always"
        xlink:href="#linearGradient3208"
        id="linearGradient3210"
        x1="41.998138"
        y1="66.192856"
        x2="26.152761"
        y2="67.060516"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-8.2361753,-1.7306854)" />
     <linearGradient
        inkscape:collect="always"
        xlink:href="#linearGradient3466"
        id="linearGradient3468"
        x1="53.447403"
        y1="107.15903"
        x2="41.215515"
        y2="108.67667"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(8.3100799,-59.230147)" />
    </defs>
    <g
      inkscape:label="Layer 1"
      inkscape:groupmode="layer"
      id="layer1"
      style="display:inline">
     <g
        id="g3765">
       <g
          id="g4894"
          transform="rotate(-179.96117,68.024306,68.164976)">
         <path
            style="fill:#808080;fill-rule:evenodd"
            id="path4602"
            sodipodi:type="arc"
            sodipodi:cx="-67.987068"
            sodipodi:cy="-68.375198"
            sodipodi:rx="66.060516"
            sodipodi:ry="66.145836"
            sodipodi:start="4.712389"
            sodipodi:end="1.5707963"
            sodipodi:arc-type="chord"
            d="M -67.987068,-134.52103 A 66.060516,66.145836 0 0 1 -1.9265518,-68.375198 66.060516,66.145836 0 0 1 -67.987068,-2.2293625 Z"
            sodipodi:open="true"
            transform="matrix(-0.99999916,0.00129321,-0.00128988,-0.99999917,0,0)" />
         <path
            style="fill:#d4aa00;fill-rule:evenodd"
            id="path403"
            sodipodi:type="arc"
            sodipodi:cx="67.888084"
            sodipodi:cy="68.042732"
            sodipodi:rx="66.145836"
            sodipodi:ry="66.145836"
            sodipodi:start="4.712389"
            sodipodi:end="1.5707963"
            sodipodi:arc-type="chord"
            d="M 67.888084,1.8968964 A 66.145836,66.145836 0 0 1 134.03392,68.042732 66.145836,66.145836 0 0 1 67.888084,134.18857 Z"
            sodipodi:open="true" />
         <ellipse
            style="fill:url(#linearGradient2348);fill-opacity:1;fill-rule:evenodd;stroke-width:1.29478"
            id="path550"
            ry="13.555489"
            rx="13.439517"
            cy="48.56498"
            cx="92.992104" />
         <circle
            style="fill:url(#linearGradient2718);fill-opacity:1;fill-rule:evenodd"
            id="path2564"
            cx="111.47066"
            cy="90.244766"
            r="7.9375" />
         <ellipse
            style="fill:url(#linearGradient3210);fill-opacity:1;fill-rule:evenodd;stroke-width:0.264583"
            id="path2806"
            cx="24.881218"
            cy="64.620605"
            rx="6.8846922"
            ry="7.2964578" />
         <ellipse
            style="fill:url(#linearGradient3468);fill-opacity:1;fill-rule:evenodd;stroke-width:0.264583"
            id="path3298"
            cx="56.653912"
            cy="48.771484"
            rx="5.434382"
            ry="5.4852648"
            inkscape:transform-center-y="7.5709159" />
       </g>
     </g>
    </g>`,
  "Full": `<defs
      id="defs2">
    <linearGradient
        inkscape:collect="always"
        id="linearGradient2716">
      <stop
          style="stop-color:#aa8800;stop-opacity:1;"
          offset="0"
          id="stop2712" />
      <stop
          style="stop-color:#aa8800;stop-opacity:0;"
          offset="1"
          id="stop2714" />
    </linearGradient>
    <linearGradient
        inkscape:collect="always"
        id="linearGradient2346">
      <stop
          style="stop-color:#aa8800;stop-opacity:1;"
          offset="0"
          id="stop2342" />
      <stop
          style="stop-color:#aa8800;stop-opacity:0;"
          offset="1"
          id="stop2344" />
    </linearGradient>
    <linearGradient
        inkscape:collect="always"
        xlink:href="#linearGradient2346"
        id="linearGradient2348"
        x1="99.674171"
        y1="49.291107"
        x2="76.746254"
        y2="50.482792"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-140.72089,-137.50041)" />
    <linearGradient
        inkscape:collect="always"
        xlink:href="#linearGradient2716"
        id="linearGradient2718"
        x1="115.232"
        y1="90.451729"
        x2="102.27573"
        y2="90.780258"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-136.09479,-136.28384)" />
    <linearGradient
        inkscape:collect="always"
        xlink:href="#linearGradient2346"
        id="linearGradient16895"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(0.78511989,0,0,0.77642859,-159.16398,-75.95819)"
        x1="99.674171"
        y1="49.291107"
        x2="76.746254"
        y2="50.482792" />
    </defs>
    <g
      inkscape:label="Layer 1"
      inkscape:groupmode="layer"
      id="layer1"
      style="display:inline">
    <g
        id="g3765">
      <path
          style="fill:#d4aa00;fill-rule:evenodd;fill-opacity:1"
          id="path4602"
          sodipodi:type="arc"
          sodipodi:cx="67.931824"
          sodipodi:cy="68.084526"
          sodipodi:rx="66.060516"
          sodipodi:ry="66.145836"
          sodipodi:start="4.712389"
          sodipodi:end="1.5707963"
          sodipodi:arc-type="chord"
          sodipodi:open="true"
          transform="matrix(0.99999981,-6.1549898e-4,6.1216897e-4,0.99999981,0,0)"
          d="M 67.931824,1.9386902 A 66.060516,66.145836 0 0 1 133.99234,68.084526 66.060516,66.145836 0 0 1 67.931824,134.23036 Z" />
      <path
          style="fill:#d4aa00;fill-rule:evenodd"
          id="path403"
          sodipodi:type="arc"
          sodipodi:cx="-68.206711"
          sodipodi:cy="-68.241104"
          sodipodi:rx="66.145836"
          sodipodi:ry="66.145836"
          sodipodi:start="4.712389"
          sodipodi:end="1.5707963"
          sodipodi:arc-type="chord"
          sodipodi:open="true"
          d="M -68.206711,-134.38694 A 66.145836,66.145836 0 0 1 -2.0608749,-68.241104 66.145836,66.145836 0 0 1 -68.206711,-2.0952682 Z"
          transform="rotate(-179.96117)" />
      <ellipse
          style="fill:url(#linearGradient2348);fill-opacity:1;fill-rule:evenodd;stroke-width:1.29478"
          id="path550"
          ry="13.555489"
          rx="13.439517"
          cy="-88.935425"
          cx="-47.728783"
          transform="rotate(-179.96117)" />
      <circle
          style="fill:url(#linearGradient2718);fill-opacity:1;fill-rule:evenodd"
          id="path2564"
          cx="-24.624136"
          cy="-46.03907"
          r="7.9375"
          transform="rotate(-179.96117)" />
      <ellipse
          style="fill:url(#linearGradient16895);fill-opacity:1;fill-rule:evenodd;stroke-width:1.01091"
          id="ellipse16813"
          ry="10.524869"
          rx="10.551632"
          cy="-38.250946"
          cx="-86.154022"
          transform="matrix(-0.99999978,-6.7020903e-4,6.8529755e-4,-0.99999977,0,0)" />
    </g>
    </g>`,
  "Last Quarter": `<defs
      id="defs2">
    <linearGradient
        inkscape:collect="always"
        id="linearGradient3466">
      <stop
          style="stop-color:#483e37;stop-opacity:1;"
          offset="0"
          id="stop3462" />
      <stop
          style="stop-color:#483e37;stop-opacity:0;"
          offset="1"
          id="stop3464" />
    </linearGradient>
    <linearGradient
        inkscape:collect="always"
        id="linearGradient3208">
      <stop
          style="stop-color:#483e37;stop-opacity:1;"
          offset="0"
          id="stop3204" />
      <stop
          style="stop-color:#483e37;stop-opacity:0;"
          offset="1"
          id="stop3206" />
    </linearGradient>
    <linearGradient
        inkscape:collect="always"
        id="linearGradient2716">
      <stop
          style="stop-color:#aa8800;stop-opacity:1;"
          offset="0"
          id="stop2712" />
      <stop
          style="stop-color:#aa8800;stop-opacity:0;"
          offset="1"
          id="stop2714" />
    </linearGradient>
    <linearGradient
        inkscape:collect="always"
        id="linearGradient2346">
      <stop
          style="stop-color:#aa8800;stop-opacity:1;"
          offset="0"
          id="stop2342" />
      <stop
          style="stop-color:#aa8800;stop-opacity:0;"
          offset="1"
          id="stop2344" />
    </linearGradient>
    <linearGradient
        inkscape:collect="always"
        xlink:href="#linearGradient2346"
        id="linearGradient2348"
        x1="99.674171"
        y1="49.291107"
        x2="76.746254"
        y2="50.482792"
        gradientUnits="userSpaceOnUse" />
    <linearGradient
        inkscape:collect="always"
        xlink:href="#linearGradient2716"
        id="linearGradient2718"
        x1="115.232"
        y1="90.451729"
        x2="102.27573"
        y2="90.780258"
        gradientUnits="userSpaceOnUse" />
    <linearGradient
        inkscape:collect="always"
        xlink:href="#linearGradient3208"
        id="linearGradient3210"
        x1="41.998138"
        y1="66.192856"
        x2="26.152761"
        y2="67.060516"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-8.2361753,-1.7306854)" />
    <linearGradient
        inkscape:collect="always"
        xlink:href="#linearGradient3466"
        id="linearGradient3468"
        x1="53.447403"
        y1="107.15903"
        x2="41.215515"
        y2="108.67667"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(8.3100799,-59.230147)" />
    </defs>
    <g
      inkscape:label="Layer 1"
      inkscape:groupmode="layer"
      id="layer1"
      style="display:inline">
    <g
        id="g3765">
      <path
          style="fill:#808080;fill-rule:evenodd"
          id="path4602"
          sodipodi:type="arc"
          sodipodi:cx="-67.987068"
          sodipodi:cy="-68.375198"
          sodipodi:rx="66.060516"
          sodipodi:ry="66.145836"
          sodipodi:start="4.712389"
          sodipodi:end="1.5707963"
          sodipodi:arc-type="chord"
          d="M -67.987068,-134.52103 A 66.060516,66.145836 0 0 1 -1.9265518,-68.375198 66.060516,66.145836 0 0 1 -67.987068,-2.2293625 Z"
          sodipodi:open="true"
          transform="matrix(-0.99999916,0.00129321,-0.00128988,-0.99999917,0,0)" />
      <path
          style="fill:#d4aa00;fill-rule:evenodd"
          id="path403"
          sodipodi:type="arc"
          sodipodi:cx="67.888084"
          sodipodi:cy="68.042732"
          sodipodi:rx="66.145836"
          sodipodi:ry="66.145836"
          sodipodi:start="4.712389"
          sodipodi:end="1.5707963"
          sodipodi:arc-type="chord"
          d="M 67.888084,1.8968964 A 66.145836,66.145836 0 0 1 134.03392,68.042732 66.145836,66.145836 0 0 1 67.888084,134.18857 Z"
          sodipodi:open="true" />
      <ellipse
          style="fill:url(#linearGradient2348);fill-opacity:1;fill-rule:evenodd;stroke-width:1.29478"
          id="path550"
          ry="13.555489"
          rx="13.439517"
          cy="48.56498"
          cx="92.992104" />
      <circle
          style="fill:url(#linearGradient2718);fill-opacity:1;fill-rule:evenodd"
          id="path2564"
          cx="111.47066"
          cy="90.244766"
          r="7.9375" />
      <ellipse
          style="fill:url(#linearGradient3210);fill-opacity:1;fill-rule:evenodd;stroke-width:0.264583"
          id="path2806"
          cx="24.881218"
          cy="64.620605"
          rx="6.8846922"
          ry="7.2964578" />
      <ellipse
          style="fill:url(#linearGradient3468);fill-opacity:1;fill-rule:evenodd;stroke-width:0.264583"
          id="path3298"
          cx="56.653912"
          cy="48.771484"
          rx="5.434382"
          ry="5.4852648"
          inkscape:transform-center-y="7.5709159" />
    </g>
    </g>`,
  "New": `<defs
      id="defs2">
    <linearGradient
        inkscape:collect="always"
        id="linearGradient17626">
      <stop
          style="stop-color:#666666;stop-opacity:1;"
          offset="0"
          id="stop17622" />
      <stop
          style="stop-color:#666666;stop-opacity:0;"
          offset="1"
          id="stop17624" />
    </linearGradient>
    <linearGradient
        inkscape:collect="always"
        id="linearGradient17390">
      <stop
          style="stop-color:#666666;stop-opacity:1;"
          offset="0"
          id="stop17386" />
      <stop
          style="stop-color:#666666;stop-opacity:0;"
          offset="1"
          id="stop17388" />
    </linearGradient>
    <linearGradient
        inkscape:collect="always"
        id="linearGradient17212">
      <stop
          style="stop-color:#666666;stop-opacity:1;"
          offset="0"
          id="stop17208" />
      <stop
          style="stop-color:#666666;stop-opacity:0;"
          offset="1"
          id="stop17210" />
    </linearGradient>
    <linearGradient
        inkscape:collect="always"
        xlink:href="#linearGradient17212"
        id="linearGradient17214"
        x1="-94.966858"
        y1="-36.469551"
        x2="-72.069633"
        y2="-40.557178"
        gradientUnits="userSpaceOnUse" />
    <linearGradient
        inkscape:collect="always"
        xlink:href="#linearGradient17390"
        id="linearGradient17392"
        x1="-53.787743"
        y1="-87.366905"
        x2="-29.146341"
        y2="-90.552376"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-33.032458,7.3247629)" />
    <linearGradient
        inkscape:collect="always"
        xlink:href="#linearGradient17626"
        id="linearGradient17628"
        x1="-28.252384"
        y1="-44.340385"
        x2="-13.858905"
        y2="-53.682266"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(1.2522015,-6.8583472)" />
    </defs>
    <g
      inkscape:label="Layer 1"
      inkscape:groupmode="layer"
      id="layer1"
      style="display:inline">
    <g
        id="g3765">
      <path
          style="fill:#808080;fill-rule:evenodd;fill-opacity:1"
          id="path4602"
          sodipodi:type="arc"
          sodipodi:cx="67.931824"
          sodipodi:cy="68.084526"
          sodipodi:rx="66.060516"
          sodipodi:ry="66.145836"
          sodipodi:start="4.712389"
          sodipodi:end="1.5707963"
          sodipodi:arc-type="chord"
          sodipodi:open="true"
          transform="matrix(0.99999981,-6.1549898e-4,6.1216897e-4,0.99999981,0,0)"
          d="M 67.931824,1.9386902 A 66.060516,66.145836 0 0 1 133.99234,68.084526 66.060516,66.145836 0 0 1 67.931824,134.23036 Z" />
      <path
          style="fill:#808080;fill-rule:evenodd"
          id="path403"
          sodipodi:type="arc"
          sodipodi:cx="-68.206711"
          sodipodi:cy="-68.241104"
          sodipodi:rx="66.145836"
          sodipodi:ry="66.145836"
          sodipodi:start="4.712389"
          sodipodi:end="1.5707963"
          sodipodi:arc-type="chord"
          sodipodi:open="true"
          d="M -68.206711,-134.38694 A 66.145836,66.145836 0 0 1 -2.0608749,-68.241104 66.145836,66.145836 0 0 1 -68.206711,-2.0952682 Z"
          transform="rotate(-179.96117)" />
      <ellipse
          style="fill:url(#linearGradient17392);fill-opacity:1;fill-rule:evenodd;stroke-width:1.29478"
          id="path550"
          ry="13.555489"
          rx="13.439517"
          cy="-81.610664"
          cx="-80.761238"
          transform="rotate(-179.96117)" />
      <circle
          style="fill:url(#linearGradient17628);fill-opacity:1;fill-rule:evenodd"
          id="path2564"
          cx="-23.371935"
          cy="-52.897419"
          r="7.9375"
          transform="rotate(-179.96117)" />
      <ellipse
          style="fill:url(#linearGradient17214);fill-opacity:1;fill-rule:evenodd;stroke-width:1.01091"
          id="ellipse16813"
          ry="10.524869"
          rx="10.551632"
          cy="-38.250946"
          cx="-86.154022"
          transform="matrix(-0.99999978,-6.7020903e-4,6.8529755e-4,-0.99999977,0,0)" />
    </g>
    </g>`,
  "Waning Crescent": `<defs
      id="defs2">
    <linearGradient
        inkscape:collect="always"
        id="linearGradient17390">
      <stop
          style="stop-color:#666666;stop-opacity:1;"
          offset="0"
          id="stop17386" />
      <stop
          style="stop-color:#666666;stop-opacity:0;"
          offset="1"
          id="stop17388" />
    </linearGradient>
    <linearGradient
        inkscape:collect="always"
        id="linearGradient17212">
      <stop
          style="stop-color:#666666;stop-opacity:1;"
          offset="0"
          id="stop17208" />
      <stop
          style="stop-color:#666666;stop-opacity:0;"
          offset="1"
          id="stop17210" />
    </linearGradient>
    <linearGradient
        inkscape:collect="always"
        xlink:href="#linearGradient17212"
        id="linearGradient17214"
        x1="-94.966858"
        y1="-36.469551"
        x2="-72.069633"
        y2="-40.557178"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-18.573837,-2.0874081)" />
    <linearGradient
        inkscape:collect="always"
        xlink:href="#linearGradient17390"
        id="linearGradient17392"
        x1="-53.787743"
        y1="-87.366905"
        x2="-29.146341"
        y2="-90.552376"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-28.319448,-5.5687213)" />
    </defs>
    <g
      inkscape:label="Layer 1"
      inkscape:groupmode="layer"
      id="layer1"
      style="display:inline">
    <g
        id="g3765">
      <path
          style="fill:#808080;fill-rule:evenodd;fill-opacity:1"
          id="path4602"
          sodipodi:type="arc"
          sodipodi:cx="67.931824"
          sodipodi:cy="68.084526"
          sodipodi:rx="66.060516"
          sodipodi:ry="66.145836"
          sodipodi:start="4.712389"
          sodipodi:end="1.5707963"
          sodipodi:arc-type="chord"
          sodipodi:open="true"
          transform="matrix(0.99999981,-6.1549898e-4,6.1216897e-4,0.99999981,0,0)"
          d="M 67.931824,1.9386902 A 66.060516,66.145836 0 0 1 133.99234,68.084526 66.060516,66.145836 0 0 1 67.931824,134.23036 Z" />
      <path
          style="fill:#d4aa00;fill-rule:evenodd"
          id="path403"
          sodipodi:type="arc"
          sodipodi:cx="-68.206711"
          sodipodi:cy="-68.241104"
          sodipodi:rx="66.145836"
          sodipodi:ry="66.145836"
          sodipodi:start="4.712389"
          sodipodi:end="1.5707963"
          sodipodi:arc-type="chord"
          d="M -68.206711,-134.38694 A 66.145836,66.145836 0 0 1 -2.0608749,-68.241104 66.145836,66.145836 0 0 1 -68.206711,-2.0952682 Z"
          transform="rotate(-179.96117)"
          sodipodi:open="true" />
      <ellipse
          style="fill:#808080;fill-opacity:1;fill-rule:evenodd;stroke-width:0.264583"
          id="path18292"
          ry="66.104271"
          rx="38.842342"
          cy="68.245766"
          cx="70.366394" />
      <ellipse
          style="fill:url(#linearGradient17392);fill-opacity:1;fill-rule:evenodd;stroke-width:1.29478"
          id="path550"
          ry="13.555489"
          rx="13.439517"
          cy="-94.50415"
          cx="-76.048225"
          transform="rotate(-179.96117)" />
      <ellipse
          style="fill:url(#linearGradient17214);fill-opacity:1;fill-rule:evenodd;stroke-width:1.01091"
          id="ellipse16813"
          ry="10.524869"
          rx="10.551632"
          cy="-40.338356"
          cx="-104.72786"
          transform="matrix(-0.99999978,-6.7020903e-4,6.8529755e-4,-0.99999977,0,0)" />
    </g>
    </g>`,
  "Waning Gibbous": `<defs
      id="defs2">
    <linearGradient
        inkscape:collect="always"
        id="linearGradient22233">
      <stop
          style="stop-color:#aa8800;stop-opacity:1;"
          offset="0"
          id="stop22229" />
      <stop
          style="stop-color:#aa8800;stop-opacity:0;"
          offset="1"
          id="stop22231" />
    </linearGradient>
    <linearGradient
        inkscape:collect="always"
        id="linearGradient22027">
      <stop
          style="stop-color:#aa8800;stop-opacity:1;"
          offset="0"
          id="stop22023" />
      <stop
          style="stop-color:#aa8800;stop-opacity:0;"
          offset="1"
          id="stop22025" />
    </linearGradient>
    <linearGradient
        inkscape:collect="always"
        xlink:href="#linearGradient22027"
        id="linearGradient22029"
        x1="-60.910599"
        y1="-94.467773"
        x2="-90.929558"
        y2="-84.098351"
        gradientUnits="userSpaceOnUse" />
    <linearGradient
        inkscape:collect="always"
        xlink:href="#linearGradient22233"
        id="linearGradient22235"
        x1="-26.909929"
        y1="-54.337395"
        x2="-48.118111"
        y2="-44.464043"
        gradientUnits="userSpaceOnUse" />
    </defs>
    <g
      inkscape:label="Layer 1"
      inkscape:groupmode="layer"
      id="layer1"
      style="display:inline">
    <g
        id="g3765">
      <path
          style="fill:#808080;fill-opacity:1;fill-rule:evenodd"
          id="path4602"
          sodipodi:type="arc"
          sodipodi:cx="67.931824"
          sodipodi:cy="68.084526"
          sodipodi:rx="66.060516"
          sodipodi:ry="66.145836"
          sodipodi:start="4.712389"
          sodipodi:end="1.5707963"
          sodipodi:arc-type="chord"
          sodipodi:open="true"
          transform="matrix(0.99999981,-6.1549898e-4,6.1216897e-4,0.99999981,0,0)"
          d="M 67.931824,1.9386902 A 66.060516,66.145836 0 0 1 133.99234,68.084526 66.060516,66.145836 0 0 1 67.931824,134.23036 Z" />
      <path
          style="fill:#d4aa00;fill-rule:evenodd"
          id="path403"
          sodipodi:type="arc"
          sodipodi:cx="-68.206711"
          sodipodi:cy="-68.241104"
          sodipodi:rx="66.145836"
          sodipodi:ry="66.145836"
          sodipodi:start="4.712389"
          sodipodi:end="1.5707963"
          sodipodi:arc-type="chord"
          transform="rotate(-179.96117)"
          sodipodi:open="true"
          d="M -68.206711,-134.38694 A 66.145836,66.145836 0 0 1 -2.0608749,-68.241104 66.145836,66.145836 0 0 1 -68.206711,-2.0952682 Z" />
      <ellipse
          style="fill:#d4aa00;fill-opacity:1;fill-rule:evenodd;stroke-width:0.262904"
          id="path18292"
          ry="66.104271"
          rx="38.351067"
          cy="68.245766"
          cx="69.875122" />
      <ellipse
          style="fill:url(#linearGradient22029);fill-opacity:1;fill-rule:evenodd;stroke-width:1.29478"
          id="path550"
          ry="13.555489"
          rx="13.439517"
          cy="-88.534172"
          cx="-69.985252"
          transform="rotate(-179.96117)" />
      <ellipse
          style="fill:url(#linearGradient22235);fill-opacity:1;fill-rule:evenodd;stroke-width:1.01091"
          id="ellipse16813"
          ry="10.524869"
          rx="10.551632"
          cy="-51.62466"
          cx="-32.622433"
          transform="matrix(-0.99999978,-6.7020903e-4,6.8529755e-4,-0.99999977,0,0)" />
    </g>
    </g>`,
  "Waxing Crescent": `<defs
      id="defs2">
    <linearGradient
        inkscape:collect="always"
        id="linearGradient17390">
      <stop
          style="stop-color:#666666;stop-opacity:1;"
          offset="0"
          id="stop17386" />
      <stop
          style="stop-color:#666666;stop-opacity:0;"
          offset="1"
          id="stop17388" />
    </linearGradient>
    <linearGradient
        inkscape:collect="always"
        id="linearGradient17212">
      <stop
          style="stop-color:#666666;stop-opacity:1;"
          offset="0"
          id="stop17208" />
      <stop
          style="stop-color:#666666;stop-opacity:0;"
          offset="1"
          id="stop17210" />
    </linearGradient>
    <linearGradient
        inkscape:collect="always"
        xlink:href="#linearGradient17212"
        id="linearGradient17214"
        x1="-94.966858"
        y1="-36.469551"
        x2="-72.069633"
        y2="-40.557178"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-18.573837,-2.0874081)" />
    <linearGradient
        inkscape:collect="always"
        xlink:href="#linearGradient17390"
        id="linearGradient17392"
        x1="-53.787743"
        y1="-87.366905"
        x2="-29.146341"
        y2="-90.552376"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-28.319448,-5.5687213)" />
    </defs>
    <g
      inkscape:label="Layer 1"
      inkscape:groupmode="layer"
      id="layer1"
      style="display:inline">
    <g
        id="g3765">
      <g
          id="g21843"
          transform="rotate(179.8143,68.024309,68.164999)">
        <path
            style="fill:#808080;fill-opacity:1;fill-rule:evenodd"
            id="path4602"
            sodipodi:type="arc"
            sodipodi:cx="67.931824"
            sodipodi:cy="68.084526"
            sodipodi:rx="66.060516"
            sodipodi:ry="66.145836"
            sodipodi:start="4.712389"
            sodipodi:end="1.5707963"
            sodipodi:arc-type="chord"
            sodipodi:open="true"
            transform="matrix(0.99999981,-6.1549898e-4,6.1216897e-4,0.99999981,0,0)"
            d="M 67.931824,1.9386902 A 66.060516,66.145836 0 0 1 133.99234,68.084526 66.060516,66.145836 0 0 1 67.931824,134.23036 Z" />
        <path
            style="fill:#d4aa00;fill-rule:evenodd"
            id="path403"
            sodipodi:type="arc"
            sodipodi:cx="-68.206711"
            sodipodi:cy="-68.241104"
            sodipodi:rx="66.145836"
            sodipodi:ry="66.145836"
            sodipodi:start="4.712389"
            sodipodi:end="1.5707963"
            sodipodi:arc-type="chord"
            d="M -68.206711,-134.38694 A 66.145836,66.145836 0 0 1 -2.0608749,-68.241104 66.145836,66.145836 0 0 1 -68.206711,-2.0952682 Z"
            transform="rotate(-179.96117)"
            sodipodi:open="true" />
        <ellipse
            style="fill:#808080;fill-opacity:1;fill-rule:evenodd;stroke-width:0.264583"
            id="path18292"
            ry="66.104271"
            rx="38.842342"
            cy="68.245766"
            cx="70.366394" />
        <ellipse
            style="fill:url(#linearGradient17392);fill-opacity:1;fill-rule:evenodd;stroke-width:1.29478"
            id="path550"
            ry="13.555489"
            rx="13.439517"
            cy="-94.50415"
            cx="-76.048225"
            transform="rotate(-179.96117)" />
        <ellipse
            style="fill:url(#linearGradient17214);fill-opacity:1;fill-rule:evenodd;stroke-width:1.01091"
            id="ellipse16813"
            ry="10.524869"
            rx="10.551632"
            cy="-40.338356"
            cx="-104.72786"
            transform="matrix(-0.99999978,-6.7020903e-4,6.8529755e-4,-0.99999977,0,0)" />
      </g>
    </g>
    </g>`,
  "Waxing Gibbous": `<defs
      id="defs2">
    <linearGradient
        inkscape:collect="always"
        id="linearGradient22233">
      <stop
          style="stop-color:#aa8800;stop-opacity:1;"
          offset="0"
          id="stop22229" />
      <stop
          style="stop-color:#aa8800;stop-opacity:0;"
          offset="1"
          id="stop22231" />
    </linearGradient>
    <linearGradient
        inkscape:collect="always"
        id="linearGradient22027">
      <stop
          style="stop-color:#aa8800;stop-opacity:1;"
          offset="0"
          id="stop22023" />
      <stop
          style="stop-color:#aa8800;stop-opacity:0;"
          offset="1"
          id="stop22025" />
    </linearGradient>
    <linearGradient
        inkscape:collect="always"
        xlink:href="#linearGradient22027"
        id="linearGradient22029"
        x1="-60.910599"
        y1="-94.467773"
        x2="-90.929558"
        y2="-84.098351"
        gradientUnits="userSpaceOnUse" />
    <linearGradient
        inkscape:collect="always"
        xlink:href="#linearGradient22233"
        id="linearGradient22235"
        x1="-26.909929"
        y1="-54.337395"
        x2="-48.118111"
        y2="-44.464043"
        gradientUnits="userSpaceOnUse" />
    </defs>
    <g
      inkscape:label="Layer 1"
      inkscape:groupmode="layer"
      id="layer1"
      style="display:inline">
    <g
        id="g3765">
      <g
          id="g22634"
          transform="rotate(-179.61737,68.024309,68.164999)">
        <path
            style="fill:#808080;fill-opacity:1;fill-rule:evenodd"
            id="path4602"
            sodipodi:type="arc"
            sodipodi:cx="67.931824"
            sodipodi:cy="68.084526"
            sodipodi:rx="66.060516"
            sodipodi:ry="66.145836"
            sodipodi:start="4.712389"
            sodipodi:end="1.5707963"
            sodipodi:arc-type="chord"
            sodipodi:open="true"
            transform="matrix(0.99999981,-6.1549898e-4,6.1216897e-4,0.99999981,0,0)"
            d="M 67.931824,1.9386902 A 66.060516,66.145836 0 0 1 133.99234,68.084526 66.060516,66.145836 0 0 1 67.931824,134.23036 Z" />
        <path
            style="fill:#d4aa00;fill-rule:evenodd"
            id="path403"
            sodipodi:type="arc"
            sodipodi:cx="-68.206711"
            sodipodi:cy="-68.241104"
            sodipodi:rx="66.145836"
            sodipodi:ry="66.145836"
            sodipodi:start="4.712389"
            sodipodi:end="1.5707963"
            sodipodi:arc-type="chord"
            transform="rotate(-179.96117)"
            sodipodi:open="true"
            d="M -68.206711,-134.38694 A 66.145836,66.145836 0 0 1 -2.0608749,-68.241104 66.145836,66.145836 0 0 1 -68.206711,-2.0952682 Z" />
        <ellipse
            style="fill:#d4aa00;fill-opacity:1;fill-rule:evenodd;stroke-width:0.262904"
            id="path18292"
            ry="66.104271"
            rx="38.351067"
            cy="68.245766"
            cx="69.875122" />
        <ellipse
            style="fill:url(#linearGradient22029);fill-opacity:1;fill-rule:evenodd;stroke-width:1.29478"
            id="path550"
            ry="13.555489"
            rx="13.439517"
            cy="-88.534172"
            cx="-69.985252"
            transform="rotate(-179.96117)" />
        <ellipse
            style="fill:url(#linearGradient22235);fill-opacity:1;fill-rule:evenodd;stroke-width:1.01091"
            id="ellipse16813"
            ry="10.524869"
            rx="10.551632"
            cy="-51.62466"
            cx="-32.622433"
            transform="matrix(-0.99999978,-6.7020903e-4,6.8529755e-4,-0.99999977,0,0)" />
      </g>
    </g>
    </g>`
};

export function lunarPhaseAndIcon(date = new Date()) {

  let phase = getLunarPhase(date);

  return {
    phase,
    icon: images[phase]
  };
}